import { AuthEntry } from '@anm/api/modules/auth';
import FaqSection from '@anm/components/sections/FaqSection';
import studioFaqAuthData from '@anm/data/faq/studio/studioFaqAuthData';
import { getStudioLinks } from '@anm/data/links';
import compose from 'lodash/fp/compose';
import React, { FC } from 'react';

import bootstrapPage, { BootstrapPageProps } from '../../HOCs/bootstrapPage';
import injectSagasAndReducers from '../../HOCs/injectSagasAndReducers';
import withSignUpRedirectNotification from '../../HOCs/withSignUpRedirectNotification';
import MetaHead from '../../components/MetaHead';
import { TermsUseProvider } from '@anm/components/TermsUse';
import { TitleTextVariants } from '../../components/auth/AuthSection';
import { SocialEmailButtonsBlockProvider } from '../../components/auth/SocialEmailButtonsBlock';
import { SubmitFormProvider } from '../../components/auth/SubmitForm/Form';
import SignUpSection from '../../components/auth/signup/SignUpSection';
import StudioLayout from '../../components/layouts/StudioLayout';
import vtConfig from '../../config';
import { RouterRedirectQuery } from '../../helpers/redirects/reactRouterRedirect';
import collapseReducer, { collapseSaga } from '../../store/modules/collapse';
import getFromCdn from '@anm/helpers/getFromCdn';

export type SignUpQuery = RouterRedirectQuery & {
  entry: AuthEntry;
};

const titleTextVariants: TitleTextVariants = {
  welcome: {
    title: 'Welcome to Animatron Studio',
    description:
      'Sign up for free and begin designing awesome animated web content'
  }
};

const { urls } = vtConfig();
const { termsUse, privacyPolicy } = getStudioLinks(urls.studio);

const SignUpPage: FC<BootstrapPageProps> = ({ path }) => {
  const title = 'Sign Up';
  const description =
    'Sign up free to Animatron Studio, a powerful online animation maker. Create stunning animations and videos with a simple drag-and-drop!';
  const previewUrl = `${getFromCdn('images/data/mainpage_preview.jpg')}`;
  const previewSize = { width: 400, height: 300 };

  return (
    <>
      <MetaHead
        path={path}
        title={title}
        description={description}
        preview={previewUrl}
        size={previewSize}
      />
      <StudioLayout navigationVariant="pink" footerVariant="small">
        <SubmitFormProvider value={{ buttonVariant: 'red' }}>
          <SocialEmailButtonsBlockProvider value={{ buttonVariant: 'red' }}>
            <TermsUseProvider
              value={{
                termsLink: { ...termsUse, route: termsUse.href },
                privacyLink: { ...privacyPolicy, route: privacyPolicy.href }
              }}
            >
              <SignUpSection
                titleTextVariants={titleTextVariants}
                backgroundVariant="white-to-dark-blue"
              />
            </TermsUseProvider>
          </SocialEmailButtonsBlockProvider>
        </SubmitFormProvider>
        <FaqSection
          title="Frequently Asked Questions"
          list={studioFaqAuthData}
        />
      </StudioLayout>
    </>
  );
};

export default compose(
  withSignUpRedirectNotification,
  bootstrapPage,
  injectSagasAndReducers(() => [...collapseSaga()], {
    collapse: collapseReducer
  },
  { id: 'SignUpPage' })
)(SignUpPage);
